import { render } from "./SimpleDropdown.vue?vue&type=template&id=6ca9edc9&lang=true"
import script from "./SimpleDropdown.vue?vue&type=script&lang=js"
export * from "./SimpleDropdown.vue?vue&type=script&lang=js"
script.render = render

export default script